import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TSvgIconProps } from '../icon.component';

const PdsUndo = forwardRef(
  ({ ...props }: TSvgIconProps, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        preserveAspectRatio="none"
        viewBox="0 0 24 24"
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M5.10315 8.00004C7.30798 4.17443 12.1896 2.86502 16.0066 5.07267C19.8247 7.28091 21.1342 12.1732 18.9288 15.9999C16.7239 19.8255 11.8423 21.1349 8.02529 18.9272C6.85864 18.2525 5.92816 17.3292 5.25953 16.2631C4.9661 15.7952 4.34893 15.6538 3.88105 15.9472C3.41316 16.2406 3.27174 16.8578 3.56517 17.3257C4.40256 18.6609 5.56831 19.8166 7.02397 20.6585C11.7996 23.4206 17.9054 21.7807 20.6616 16.9985C23.4172 12.2173 21.7826 6.10287 17.008 3.34138C12.2662 0.598904 6.21313 2.19609 3.42955 6.89997L2.96698 5.14503C2.82621 4.61098 2.27917 4.29217 1.74513 4.43293C1.21108 4.57369 0.892264 5.12073 1.03303 5.65478L2.14007 9.85478C2.20803 10.1126 2.37614 10.3326 2.60707 10.4659C2.83799 10.5993 3.11259 10.6348 3.36985 10.5647L7.50138 9.43936C8.03425 9.29421 8.34856 8.74457 8.20341 8.2117C8.05826 7.67883 7.50862 7.36452 6.97575 7.50967L5.08917 8.02355C5.09392 8.0158 5.09858 8.00796 5.10315 8.00004Z"
          fill="none"
        />
      </svg>
    );
  }
);

export default PdsUndo;
